import { OperationTemplateEditor } from './OperationTemplateEditor';
import { Alert, PageHeader } from '../../ui/components';
import { PageHelp } from '../../ui/help';
import { Link } from '../../router';

/**
 * Integración por empresa: sólo las operaciones que llegan de otros sistemas (facturación, pagos y cajas). Las cuentas del
 * inventario se configuran por categoría en la pantalla Inventario. Las demás plantillas están en Plantillas.
 */
export function IntegrationPage() {
  return (
    <>
      <PageHeader title="Integración" subtitle="Cuentas de la facturación, los pagos, las cajas y el inventario" />
      <PageHelp page="integration" />
      <OperationTemplateEditor />
      <Alert>
        <strong>Inventario:</strong> sus asientos usan las cuentas de cada categoría de productos (inventario, costo de ventas y ajustes).
        Configúrelas en <Link to="/inventory">Inventario → Cuentas por categoría</Link>.
      </Alert>
    </>
  );
}
